import {Component, OnInit} from '@angular/core';
import {MenuItem, PrimeTemplate} from 'primeng/api';
import {Menubar} from 'primeng/menubar';
import {RouterOutlet} from '@angular/router';
import {map, Observable} from 'rxjs';
import {MsalBroadcastService, MsalService} from '@azure/msal-angular';
import {AsyncPipe, NgIf} from '@angular/common';
import {ButtonDirective, ButtonIcon, ButtonLabel} from 'primeng/button';
import {filter} from 'rxjs/operators';
import {InteractionStatus} from '@azure/msal-browser';

@Component({
  selector: 'app-root',
  imports: [Menubar, PrimeTemplate, RouterOutlet, AsyncPipe, NgIf, ButtonDirective, ButtonIcon, ButtonLabel],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  items: MenuItem[] | undefined;
  isLoggedIn$!: Observable<boolean>;
  darkMode = false;

  constructor(
    private msal: MsalService,
    private msalBroadcast: MsalBroadcastService
  ) {
  }

  async ngOnInit() {
    await this.msal.instance.initialize();
    this.isLoggedIn$ = this.msalBroadcast.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      map(() => this.msal.instance.getAllAccounts().length > 0)
    );
    this.setInitialDarkMode();
  }

  login(): void {
    this.msal.loginPopup({
      scopes: ['User.Read']
    }).subscribe({
      next: result => {
        this.msal.instance.setActiveAccount(result.account);
      },
      error: err => console.error(err)
    });
  }

  logout(): void {
    this.msal.logoutPopup().subscribe({
      next: () => {
        this.msal.instance.setActiveAccount(null);
      },
      error: err => console.error(err)
    });
  }

  private setInitialDarkMode() {
    const userPrefersDark = localStorage.getItem('darkMode');
    if (userPrefersDark === null) {// if no user preference, use system preference
      this.darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    } else {
      this.darkMode = userPrefersDark === 'true';
    }

    if (this.darkMode) {
      const element = document.querySelector('html');
      element?.classList.add('dark-mode');
    }
  }

  toggleDarkMode() {
    const element = document.querySelector('html');
    element?.classList.toggle('dark-mode');
    this.darkMode = !this.darkMode;
    localStorage.setItem('darkMode', `${this.darkMode}`);
  }
}
